'use client';
import { signIn } from 'next-auth/react';
import { XIcon } from '@/components/icons';

export function LoginButton() {
  return (
    <button
      type="button"
      className="login-cta"
      onClick={() => signIn('twitter', { callbackUrl: '/' })}
    >
      <XIcon size={14} />
      Connect
    </button>
  );
}
